
import LandingPage from '../views/LandingPage.vue'

export default [
  {
    path: '/',
    name: 'LandingPage',
    component: LandingPage,
    meta: {
      requiresAuth: true,
    }
  }
]


// WEBPACK FOOTER //
// ./src/router/routes.js